module.exports = __webpack_public_path__ + "img/03_sub_no.4fc62fba.svg";